import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeIndex",
    meta: {
      title: "粤再生",
      active: "HomeIndex",

      content: {
        keywords: "粤再生",
        description: "",
      },
    },
    component: () => import("@/views/index"),
  },
  {
    path: "/company",
    name: "company",
    meta: {
      title: "公司介绍",
      active: "company",

      content: {
        keywords: "公司介绍",
        description: "",
      },
    },
    component: () => import("@/views/company"),
  },
  {
    path: "/platform",
    name: "platform",
    meta: {
      title: "平台介绍",
      active: "platform",
      content: {
        keywords: "平台介绍",
        description: "",
      },
    },
    component: () => import("@/views/platform"),
  },
  {
    path: "/news",
    name: "news",
    meta: {
      title: "新闻咨询",
      active: "news",
      content: {
        keywords: "新闻咨询",
        description: "",
      },
    },
    component: () => import("@/views/news"),
  },
  {
    path: "/newsdetail",
    name: "newsdetail",
    meta: {
      active: "news",
      title: "新闻咨询",
      content: {
        keywords: "新闻咨询",
        description: "",
      },
    },
    component: () => import("@/views/newsdetail"),
  },
  {
    path: "/propertyAuction",
    name: "propertyAuction",
    meta: {
      active: "propertyAuction",
      title: "资产处置拍卖",
      content: {
        keywords: "资产处置拍卖",
        description: "",
      },
    },
    component: () => import("@/views/propertyAuction/index.vue"),
  },
  {
    path: "/propertyAuction_detail",
    name: "propertyAuction_detail",
    meta: {
      active: "propertyAuction",
      title: "资产处置拍卖",
      content: {
        keywords: "资产处置拍卖",
        description: "",
      },
    },
    component: () => import("@/views/propertyAuction/detail.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/404"),
  },
];

const router = new VueRouter({
  // mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", to.meta.content.keywords);
    // document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  next();
});
export default router;
